import { Dayjs } from 'dayjs';

import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export const DATE_TIME_FORMAT = 'L LT';
export const DATE_FORMAT = 'L';
export const TIME_FORMAT = 'LT';

export const defaultLocale = 'fr';

export const initDayJs = () => {
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(duration);
  dayjs.extend(relativeTime);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(localizedFormat);
  dayjs.locale(defaultLocale);
};

export const formatDateTimeForServer = (date?: Dayjs | null) => {
  if (!date) {
    return null;
  }
  return date.format('YYYY-MM-DD[T]HH:mm:ss');
};

export const formatDateTime = (date?: string | Date | null) => {
  if (!date) {
    return '-';
  }

  const parsedDate = dayjs(date);

  if (!parsedDate.isValid()) {
    return '-';
  }

  return parsedDate.format(DATE_TIME_FORMAT);
};
